<div class="modal-container">
  <div class="modal-header">
    <h3 class="mat-h3">Add New Bot</h3>
  </div>

  <div class="modal-content" cdkScrollable>
    <form [formGroup]="newBotForm">
      <div class="row m-0">
        <div class="col-12">
          <div class="form-field-container">
            <label for="bot-name-input" class="form-field-label">Bot name</label>
            <mat-form-field class="gingr-input-wrapper form-field-full" appearance="outline">
              <input id="bot-name-input" matInput placeholder="Bot name" type="text" formControlName="name" required />
              @if(name.invalid) {
                <mat-error>
                  @if(name.errors?.required) {
                    <span>Please enter bot name</span>
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-field-container">
            <label for="bot-description-textarea" class="form-field-label">Description</label>
            <mat-form-field class="gingr-input-wrapper form-field-full" appearance="outline">
              <textarea id="bot-description-textarea" matInput placeholder="Description" formControlName="description" rows="3" cols="40"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-field-container">
            <label for="bot-presearch-textarea" class="form-field-label d-flex align-items-center" >Presearch</label>
            <mat-form-field class="gingr-input-wrapper form-field-full" appearance="outline">
              <textarea id="bot-presearch-textarea" matInput placeholder="Presearch" formControlName="preSearch" rows="2" cols="40"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-field-container">
            <label for="bot-instruction-textarea" class="form-field-label d-flex align-items-center">Instruction <mat-icon class="icon" matTooltip="{{ innerBotMessages.infoInstruction }}">info</mat-icon></label>
            <mat-form-field class="gingr-input-wrapper form-field-full" appearance="outline">
              <textarea id="bot-instruction-textarea" matInput placeholder="Instruction" formControlName="instruction" rows="3" cols="40"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-field-container">
            <label for="bot-behaviour-textarea" class="form-field-label d-flex align-items-center">Behaviour <mat-icon class="icon" matTooltip="{{ innerBotMessages.infoBehaviour }}">info</mat-icon></label>
            <mat-form-field class="gingr-input-wrapper form-field-full" appearance="outline">
              <textarea id="bot-behaviour-textarea" matInput placeholder="Behaviour" formControlName="behaviour" rows="3" cols="40"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-field-container">
            <label for="bot-config-textarea" class="form-field-label d-flex align-items-center">Config <mat-icon class="icon" matTooltip="{{ innerBotMessages.infoConfig }}">info</mat-icon></label>
            <mat-form-field class="gingr-input-wrapper form-field-full" appearance="outline">
              <textarea id="bot-config-textarea" matInput placeholder="Config" formControlName="config" rows="3" cols="40"></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Input Data Source Section -->
      <div class="row m-0 m-t-32">
        <div class="col-12">
          <div style="background-color: #f8f9fa; padding: 24px; border-radius: 12px">
            <h4 style="margin: 0 0 24px 0; color: #1a1a1a; font-weight: 600; font-size: 18px">Input Data Source</h4>

            <div class="row m-b-16">
              <div class="col-md-6">
                <div class="form-field-container" style="background: white; padding: 16px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);">
                  <label class="form-field-label d-flex align-items-center" style="color: #333; font-weight: 500; margin-bottom: 8px">Include init data <mat-icon class="icon" matTooltip="Include initial context data" style=" font-size: 18px; height: 18px; width: 18px; margin-left: 8px; color: #999; ">info</mat-icon></label>
                  <div class="d-flex">
                    <mat-slide-toggle formControlName="includeInitContext" color="accent" />
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-field-container"style="background: white; padding: 16px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);">
                  <label class="form-field-label d-flex align-items-center" style="color: #333; font-weight: 500; margin-bottom: 8px">Include tools <mat-icon class="icon" matTooltip="Include tools in the bot context" style=" font-size: 18px; height: 18px; width: 18px; margin-left: 8px; color: #999; " >info</mat-icon></label>
                  <div class="d-flex">
                    <mat-slide-toggle formControlName="includeTools" color="accent" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Input Bots Section -->
      <div class="row m-0 m-t-24">
        <div class="col-12">
          <div style="background-color: #f8f9fa; padding: 24px; border-radius: 12px">
            <div class="form-field-container">
              <div style="display: flex; align-items: center; margin-bottom: 20px">
                <h4 style="margin: 0; color: #1a1a1a; font-weight: 600; font-size: 18px">Input Bots</h4>
                <mat-icon class="icon" matTooltip="Select previous bots to include their responses and search results" style="font-size: 18px; height: 18px; width: 18px; margin-left: 8px; color: #999" >info</mat-icon>
              </div>

              <div formArrayName="includePreviousBots" class="m-b-16">

                @for (botControl of includePreviousBots.controls; track i; let i = $index) {
                  <div [formGroupName]="i" class="m-b-16" style=" border: 1px solid #e0e0e0; border-radius: 12px; background-color: white; padding: 20px; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08); transition: all 0.2s;">
                    <div class="row align-items-center m-b-12">
                      <div class="col-md-10">
                        <label style=" color: #666; font-size: 12px; font-weight: 500; display: block; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.5px;">Bot Selection</label>
                        <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
                          <mat-select formControlName="botId" placeholder="Select bot">
                            @for (bot of availableInnerBots; track bot._id) {
                              <mat-option [value]="bot._id">{{ bot.name }}</mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                      </div>
                      <div class="col-md-2 d-flex justify-content-end align-items-center">
                        <button type="button" mat-mini-fab color="warn" (click)="removePreviousBot(i)" matTooltip="Remove bot">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </div>
                    <div style="background: #f8f9fa; padding: 16px; border-radius: 8px">
                      <label style=" color: #666; font-size: 12px; font-weight: 500; display: block; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Include Options</label>
                      <div class="row">
                        <div class="col-md-6">
                          <mat-checkbox formControlName="includeConversation" color="accent" style="display: block; margin-bottom: 8px">
                            <span style="color: #333; font-weight: 500">Bot response</span>
                          </mat-checkbox>
                        </div>
                        <div class="col-md-6">
                          <mat-checkbox formControlName="includeSearchedSources" color="accent">
                            <span style="color: #333; font-weight: 500">Search results</span>
                          </mat-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                }

                @if(includePreviousBots.length === 0) {
                  <div class="m-b-16" style=" background: white; padding: 24px; border-radius: 12px; text-align: center; border: 2px dashed #ccc;">
                    <mat-icon style=" font-size: 48px; height: 48px; width: 48px; color: #ccc; margin-bottom: 12px;">add_circle_outline</mat-icon>
                    <p style="color: #999; margin: 0; font-size: 14px">No input bots selected yet</p>
                    <p style="color: #bbb; margin: 4px 0 0 0; font-size: 12px">Click the button below to add your first bot</p>
                  </div>
                }

              </div>

              <button type="button" mat-raised-button color="accent" (click)="addPreviousBot()" style="width: 100%; height: 48px; font-size: 15px; font-weight: 500"><mat-icon>add_circle</mat-icon> Add Input Bot</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Output Destination Section -->
      <div class="row m-0 m-t-24">
        <div class="col-12">
          <div style="background-color: #f8f9fa; padding: 24px; border-radius: 12px">
            <h4 style="margin: 0 0 20px 0; color: #1a1a1a; font-weight: 600; font-size: 18px">Output Destination</h4>
            <div class="form-field-container" style=" background: white; padding: 20px; border-radius: 8px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);">
              <label style=" color: #666; font-size: 12px; font-weight: 500; display: block; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Destination Type</label>
              <mat-form-field class="gingr-input-wrapper form-field-full" appearance="outline">
                <mat-select id="output-destination-select" formControlName="outputDestinationType" placeholder="Select output destination">
                  <mat-option value="frontend">
                    <mat-icon class="m-r-8" style="vertical-align: middle">visibility</mat-icon>
                    <span style="font-weight: 500">Frontend</span>
                    <span style="color: #999; font-size: 12px; margin-left: 8px">- Display to user</span>
                  </mat-option>
                  <mat-option value="context_only">
                    <mat-icon class="m-r-8" style="vertical-align: middle">storage</mat-icon>
                    <span style="font-weight: 500">Context Only</span>
                    <span style="color: #999; font-size: 12px; margin-left: 8px">- Internal use</span>
                  </mat-option>
                </mat-select>
                <mat-hint style="color: #666">Choose where the bot output should be sent</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- Context Assignments Section -->
      <div class="row m-0 m-t-24">
        <div class="col-12">
          <div style="background-color: #f8f9fa; padding: 24px; border-radius: 12px">
            <h4 style="margin: 0 0 20px 0; color: #1a1a1a; font-weight: 600; font-size: 18px">Context Assignments</h4>
            <div class="context-assignments-section m-b-24">
              <p class="helper-text m-b-16" style="color: #666; font-size: 13px; margin-bottom: 16px">
                Assign context groups or items to this bot. Static assignments are always loaded, Dynamic
                assignments use similarity search, and Tool assignments let the AI search on-demand.
              </p>

              <!-- Warning banner for static assignments -->
              <div
                *ngIf="getStaticWarningLevel() !== 'none'"
                class="warning-banner m-b-16"
                [ngClass]="'warning-' + getStaticWarningLevel()"
              >
                <mat-icon>warning</mat-icon>
                <span>{{ getStaticWarningMessage() }}</span>
              </div>

              <button
                type="button"
                mat-raised-button
                color="primary"
                (click)="addContextAssignment()"
                class="m-b-16"
                style="margin-bottom: 16px"
              >
                <mat-icon>add</mat-icon>
                Add Context Assignment
              </button>

              <div formArrayName="contextAssignments">
                <div
                  *ngFor="let assignment of contextAssignmentsArray.controls; let i = index"
                  [formGroupName]="i"
                  class="context-assignment-card m-b-16"
                >
                  <div class="d-flex justify-content-between align-items-center m-b-8">
                    <span class="assignment-label">Assignment {{ i + 1 }}</span>
                    <button
                      type="button"
                      mat-icon-button
                      color="warn"
                      (click)="removeContextAssignment(i)"
                      matTooltip="Remove assignment"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>

                  <div class="row">
                    <div class="form-field-container col-4">
                      <label class="form-field-label">Target Type</label>
                      <mat-form-field class="gingr-input-wrapper form-field-full" appearance="outline">
                        <mat-select
                          formControlName="targetType"
                          placeholder="Select type"
                          (selectionChange)="onTargetTypeChange(i)"
                        >
                          <mat-option value="group">Group</mat-option>
                          <mat-option value="item">Item</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

                    <div class="form-field-container col-4">
                      <label class="form-field-label">Target</label>
                      <!-- Group selector -->
                      <ng-select
                        *ngIf="getContextAssignmentGroup(i).get('targetType')?.value === 'group'"
                        formControlName="targetId"
                        [items]="availableContextGroups"
                        bindLabel="name"
                        bindValue="_id"
                        placeholder="Select group"
                        [searchable]="true"
                        [clearable]="true"
                        [virtualScroll]="true"
                        [appendTo]="'body'"
                        (change)="onAssignmentChange()"
                        class="ng-select form-field-full"
                      >
                        <ng-template ng-option-tmp let-item="item">
                          <div class="select-option" [title]="item.name">
                            {{ item.name }}
                            <span class="item-count" *ngIf="item.itemCount !== undefined"
                              >({{ item.itemCount }} items)</span
                            >
                          </div>
                        </ng-template>
                      </ng-select>
                      <!-- Item selector -->
                      <ng-select
                        *ngIf="getContextAssignmentGroup(i).get('targetType')?.value === 'item'"
                        formControlName="targetId"
                        [items]="availableContextItems"
                        bindLabel="question"
                        bindValue="_id"
                        placeholder="Search items..."
                        [searchable]="true"
                        [clearable]="true"
                        [virtualScroll]="true"
                        [appendTo]="'body'"
                        (change)="onAssignmentChange()"
                        class="ng-select form-field-full"
                      >
                        <ng-template ng-option-tmp let-item="item">
                          <div class="select-option" [title]="item.question">
                            {{ item.question | slice: 0 : 60 }}{{ item.question.length > 60 ? '...' : '' }}
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>

                    <div class="form-field-container col-4">
                      <label class="form-field-label d-flex align-items-center">
                        Assignment Type
                        <mat-icon
                          class="info-icon m-l-4"
                          matTooltip="Static: Always loaded in prompt. Dynamic: Loaded via similarity search. Tool: AI can search on-demand. Forced: Always loaded and enforced."
                          >info</mat-icon
                        >
                      </label>
                      <mat-form-field class="gingr-input-wrapper form-field-full" appearance="outline">
                        <mat-select
                          formControlName="assignmentType"
                          placeholder="Select type"
                          (selectionChange)="onAssignmentChange()"
                        >
                          <mat-option value="static">Static (Always loaded)</mat-option>
                          <mat-option value="dynamic">Dynamic (Similarity search)</mat-option>
                          <mat-option value="tool">Tool (AI search)</mat-option>
                          <mat-option value="forced">Forced (Always enforced)</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <div class="d-flex align-items-center justify-content-between">
      <button mat-stroked-button color="accent" (click)="showHistoryModal()"><mat-icon>history</mat-icon> Show History</button>

      <div class="d-flex align-items-center justify-content-end">
        <button class="action-button" mat-raised-button color="accent" [disabled]="newBotForm.invalid" (click)="addOrUpdateBot()">Save</button>
        <button class="action-button" mat-stroked-button (click)="close()">Cancel</button>
      </div>
    </div>
  </div>
</div>
